import { WorkspaceNotInitializedError } from '@/error-handler/WorkspaceNotInitializedError';
import useWorkspaceStore from '@/stores/WorkspaceStore';

function getCurrWorkspaceAlias() {
  const alias = useWorkspaceStore.getState().currWorkspace?.alias;
  if (!alias) throw new WorkspaceNotInitializedError();
  return alias;
}

export { getCurrWorkspaceAlias };
